/**
 * LaTeX Toolbar Component
 * Compact toolbar for LaTeX editor - designed to fit in header
 */

import React from 'react'
import { EditorView } from '@codemirror/view'
import clsx from 'clsx'
import FormattingButtons from './FormattingButtons'
import StructureDropdown from './StructureDropdown'
import ListButtons from './ListButtons'
import TableButton from './TableButton'
import LinkButton from './LinkButton'
import EquationButton from './EquationButton'
import ReferenceButtons from './ReferenceButtons'
import ImageButton from './ImageButton'
import SymbolPickerButton from './SymbolPickerButton'

interface LaTeXToolbarProps {
  view: EditorView | null
  theme?: 'light' | 'dark'
  className?: string
  documentContent?: string // For extracting existing labels for references
  documentId?: string // Document ID for AI features
}

const LaTeXToolbar: React.FC<LaTeXToolbarProps> = ({
  view,
  theme = 'light',
  className,
  documentContent,
  documentId,
}) => {
  const toolbarClass = clsx(
    'flex items-center gap-1 flex-shrink-0 flex-nowrap whitespace-nowrap',
    className
  )

  const dividerClass = clsx(
    'w-px h-5',
    theme === 'dark' ? 'bg-gray-600' : 'bg-gray-300'
  )

  return (
    <div className={toolbarClass}>
      {/* Formatting Buttons */}
      <FormattingButtons view={view} theme={theme} />
      
      {/* Divider */}
      <div className={dividerClass} />
      
      {/* Structure Dropdown */}
      <StructureDropdown view={view} theme={theme} />
      
      {/* Divider */}
      <div className={dividerClass} />
      
      {/* List Buttons */}
      <ListButtons view={view} theme={theme} />
      
      {/* Divider */}
      <div className={dividerClass} />
      
      {/* Table Button */}
      <TableButton view={view} theme={theme} documentId={documentId} />
      
      {/* Divider */}
      <div className={dividerClass} />
      
      {/* Equation Button */}
      <EquationButton view={view} theme={theme} documentId={documentId} />
      
      {/* Divider */}
      <div className={dividerClass} />
      
      {/* Link Button */}
      <LinkButton view={view} theme={theme} />
      
      {/* Divider */}
      <div className={dividerClass} />
      
      {/* Image Button */}
      <ImageButton view={view} theme={theme} />
      
      {/* Divider */}
      <div className={dividerClass} />
      
      {/* Reference Buttons */}
      <ReferenceButtons view={view} theme={theme} documentContent={documentContent} />
      
      {/* Divider */}
      <div className={dividerClass} />
      
      {/* Symbol Picker Button */}
      <SymbolPickerButton view={view} theme={theme} />
    </div>
  )
}

export default LaTeXToolbar
